import GenericView from 'js/views/generic.view';
import Template from 'js/templates/subscriber.group.tile.hbs';
import {template, tagName, on} from "../adapters/backbone-decorators";

@template(Template)
@tagName('span')
class SubscriberGroupTileView extends GenericView {

    constructor(options) {
        super(options);
        this.contactModel = options.contactModel;
        this.groupsCount = options.groupsCount;
        this.model.bind("change", this.render, this);
    }

    render() {
        super.render();
    }

    removeView() {
        $(this.groupsCount).each(function (index, elem) {
            elem.text(parseInt(elem.text()) - 1);
        });
        this.remove();
    }

    @on('click')
    viewGroup() {
        const theId = this.model.get(this.model.idAttribute);
        document.location.href = "#Group/" + theId;
    }

    @on('click .remove')
    removeMembership(e) {
        e.stopPropagation();
        const gid = this.model.get(this.model.idAttribute);
        this.contactModel.removeContactFromGroup(gid);
    }
}

export default SubscriberGroupTileView;
